export default {"src":"/_next/static/media/hourglass.ef240dda.svg","height":24,"width":24};